import { makeStyles, useTheme } from '@mui/styles';

const useModalStyle = () => {
    const theme = useTheme();

    return {
        useStyle: makeStyles(() => ({
            modalStyle: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '50vw',
                maxWidth: '1100px',
                // border: '1px solid transparent',
                '& .MuiPaper-root': {
                    borderRadius: '15px',
                    boxShadow: '0 2px 9px 4px rgba(0,0,0,0.2)',
                },
                '&.sideModal': {
                    left: '78%',
                    height: '95%',
                    maxWidth: '750px',
                },
            },
            modalTitle: {
                color: '#231C32',
                marginBottom: '12px',
            },
            modalContent: {
                color: '#6D7278',
                fontSize: '1rem',
                fontWeight: 400,
                marginBottom: '16px',
                maxHeight: '75vh',
                overflowY: 'auto',
            },
            modalLabel: {
                padding: '6px 0',
                marginTop: '16px',
            },
            modalSelect: {},
            modalTextArea: {},
            modalHeader: {
                borderBottom: '1px solid rgba(151, 151, 151, .16)',
                paddingBottom: '1em',
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '24px',
            },
            modalWrapper: {
                width: '75%',
                margin: '0 auto',
                padding: '24px 0',
            },
            modalActionsWrapper: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginTop: '36px',
            },
            modalActionBtn: {
                padding: '8px 16px',
                marginLeft: '16px',
            },
            '@media (max-height: 900px)': {
                modalContent: {
                    maxHeight: '50vh',
                },
            },
            '@media (max-height: 550px)': {
                modalContent: {
                    maxHeight: '25vh',
                },
            },
            [theme.breakpoints.down('lg')]: {
                modalStyle: {
                    width: '75vw',
                },
            },
            [theme.breakpoints.down('md')]: {
                modalStyle: {
                    width: '100vw',
                },
            },
            warningText: {
                opacity: 1,
                color: 'rgba(210,68,68,1)',
                fontSize: '20px',
                fontWeight: '700',
                letterSpacing: '0px',
                textAlign: 'left',
            },
        })),
        paperOverride: {
            boxShadow: '0 2px 9px 4px rgba(0,0,0,0.2)',
            borderRadius: '15px',
            outline: 'none',
        },
    };
};

export default useModalStyle;
